export default class ResponseChunk{

    static treat(responses){

        let auxResponse = {
            url: responses[0].url,
            status: responses[0].status,
            statusText: responses[0].statusText,
            data: []
        };

        auxResponse.data = responses.reduce((acc, response)=>{

            this.#isMultiStatus(response,auxResponse);

            acc.push(...response.data);
            return acc;

        },[]);

        return auxResponse;

    };

    static #isMultiStatus(response,auxResponse){

        if(
            response.status != auxResponse.status &&
            auxResponse.status != 207
        ){

            auxResponse.status = 207;
            auxResponse.statusText = "Multi-Status";

        }

    }

}